module.exports = __webpack_public_path__ + "assets/img/4-4.13a642da.png";